/**
 * UI-side permission checks. These only hide or disable controls; the backend must
 * enforce every action itself.
 *
 * The login response has no permissions yet. Until it does, every signed-in admin may
 * suspend users. Once `userInfo.permissions` exists, only those listed are allowed.
 */
function readPermissions() {
  try {
    const info = JSON.parse(localStorage.getItem('userInfo')) ?? {};
    return Array.isArray(info.permissions) ? info.permissions : null;
  } catch {
    return null;
  }
}

export function canSuspendUsers() {
  const permissions = readPermissions();
  return permissions === null ? true : permissions.includes('users:suspend');
}
